<template>
    <div class="full-space">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "HRApp"
    }
</script>

<style>

</style>


